import { SPage } from "src/components/spage";

interface IProps {}
export const UeCalendarPage = ({}: IProps) => {
  return <SPage title={"My UE Calendar"}></SPage>;
};
